(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 4998:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1913);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ FindMe; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/ui/Container/index.ts
var Container = __webpack_require__(4023);
// EXTERNAL MODULE: ./src/components/ui/NextExternalImage.tsx
var NextExternalImage = __webpack_require__(8834);
// EXTERNAL MODULE: ./src/components/ui/SectionTitle/index.tsx + 1 modules
var SectionTitle = __webpack_require__(6227);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/Index/FindMe/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute !important;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    top: 0;\n    img {\n        object-fit: cover;\n    }\n    @media (min-width: 768px) {\n        width: 50%;\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    background: red;\n    top: 0;\n    left: 0;\n    opacity: 0.1;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    a {\n        border: none;\n        height: 52px;\n        width: 135px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: white;\n        margin: 0 10px;\n        margin-top: 20px;\n        img {\n            object-fit: contain;\n        }\n    }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    min-height: 250px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: white;\n    position: relative;\n    padding: 0px 5rem;\n    background: linear-gradient(\n            rgba(32, 93, 95, 0.95) 0%,\n            rgba(30, 70, 90, 0.95) 100%\n        ),\n        url("https://cdn.zakariabenali.me/images/architecture-bg.webp")\n            no-repeat center;\n    box-shadow: rgb(55 111 116 / 30%) 0px 52px 27px -37px;\n    > * {\n        position: relative;\n    }\n    .map-image {\n        opacity: 0.6;\n    }\n    .section-title {\n        text-align: center;\n    }\n    @media (max-width: 768px) {\n        flex-direction: column;\n        justify-content: center;\n        padding: 2.5rem 2rem;\n    }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const FindMeMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-0"
})(_templateObject());
const FindMeBG = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-1"
})(_templateObject1());
const FindMeButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-2"
})(_templateObject2());
const FindMeCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/Index/FindMe/index.tsx





const FindMe = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "find-me",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMeCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMeMap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                            fill: true,
                            src: "map.png",
                            className: "map-image",
                            alt: "Photo of dotted map",
                            sizes: "(max-width:600px) 100vw, 40vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        heading: "Find me on"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMeButtons, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.fiverr.com/benalizakaria",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                                    height: "20",
                                    width: "68",
                                    src: "fiverr.svg",
                                    alt: "Fiverr Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.upwork.com/freelancers/~010aaf53dde57b55f8",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                                    height: "20",
                                    width: "68",
                                    src: "upwork.svg",
                                    alt: "Upwork Logo"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 3194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HomeSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3711);


function HomeSeo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Full stack developer and UI/UX Designer",
        description: "A Full stack And UI/UX Designer, Worked on various types of projects and I'm looking to exchange me experience with you",
        canonical: "https://www.zakariabenali.me/",
        openGraph: {
            url: "https://www.zakariabenali.me/",
            images: [
                {
                    url: "".concat("https://cdn.zakariabenali.me", "/images/seo.png"),
                    alt: "An image with some of the main technologies i use"
                }
            ],
            site_name: "Zakariabenali",
            type: "website"
        },
        twitter: {
            handle: "@handle",
            site: "@site",
            cardType: "summary_large_image"
        }
    });
}


/***/ }),

/***/ 3051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
// EXTERNAL MODULE: ./src/components/ui/animations.ts
var animations = __webpack_require__(954);
;// CONCATENATED MODULE: ./src/components/ui/Button/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n            pointer-events: none;\n            &:before {\n                content: "";\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                background: ',
        ";\n            }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background: ",
        ";\n            color: ",
        ";\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    height: 3.4375rem;\n    width: 10.6875rem;\n    font-size: 1rem;\n    background: ",
        ";\n    color: ",
        ';\n    position: relative;\n    &:after {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        border: 2px solid ',
        ";\n        transform: scale(1.2);\n        opacity: 0;\n        transition: 0.3s ease;\n        pointer-events: none;\n    }\n    &:hover:after {\n        transform: scale(1);\n        opacity: 1;\n    }\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    content: "";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 2px solid\n        ',
        ";\n    border-bottom-color: transparent;\n    transform: translate(-50%, -50%);\n    animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const ButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9542f99-0"
})(_templateObject2(), (props)=>props.theme.palette.primary.main, (props)=>props.theme.palette.primary.contrastText, (props)=>props.theme.palette.primary.main, (props)=>props.isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), props.secondary ? props.theme.palette.secondary.main : props.theme.palette.primary.main), (props)=>props.secondary && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), props.theme.palette.secondary.main, props.theme.palette.secondary.contrastText));
const ButtonSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9542f99-1"
})(_templateObject3(), (props)=>props.secondary ? props.theme.palette.secondary.contrastText : props.theme.palette.primary.contrastText, animations/* spinCenter */.jF);

;// CONCATENATED MODULE: ./src/components/ui/Button/index.tsx



const Button = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { children , isLoading , secondary , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
        ref: ref,
        isLoading: isLoading,
        secondary: secondary,
        className: "button",
        ...rest,
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSpinner, {
                secondary: secondary
            }),
            children
        ]
    });
});


/***/ }),

/***/ 1066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ FadeUp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9256);


const FadeUp = (param)=>{
    let { delay , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.div */ .E.div, {
        initial: "initial",
        animate: "animate",
        variants: {
            initial: {
                opacity: 0,
                y: 50
            },
            animate: {
                opacity: 1,
                y: 0
            }
        },
        transition: {
            delay: delay
        },
        children: children
    });
};
FadeUp.defaultProps = {
    delay: 0
};



/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ NextExternalImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



function NextExternalImage(param) {
    let { src , alt , ...rest } = param;
    const source = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return "".concat("https://cdn.zakariabenali.me", "/images/").concat(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        src: source,
        alt: alt,
        ...rest
    });
}


/***/ }),

/***/ 6227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/ui/FadeUp/index.tsx
var FadeUp = __webpack_require__(1066);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/ui/SectionTitle/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 1.25rem;\n    font-weight: 700;\n    text-transform: uppercase;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.56rem;\n    font-weight: 700;\n    max-width: 305px;\n    margin-top: 0.3125rem;\n    margin-bottom: 1.25rem;\n    @media (min-width: 600px) {\n        font-size: 2.25rem;\n    }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const SubHeading = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4efdaae7-0"
})(_templateObject(), (props)=>props.theme.palette.primary.main);
const Heading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4efdaae7-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/components/ui/SectionTitle/index.tsx



const SectionTitle = (param)=>{
    let { heading , subHeading , headingId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "section-title",
        id: headingId,
        children: [
            subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading, {
                    children: subHeading
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                delay: 0.4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                    children: heading
                })
            })
        ]
    });
};


/***/ }),

/***/ 1913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/Index/FindMe/index.tsx + 1 modules
var FindMe = __webpack_require__(4154);
// EXTERNAL MODULE: ./src/components/ui/Button/index.tsx + 1 modules
var Button = __webpack_require__(3051);
// EXTERNAL MODULE: ./src/components/ui/Container/index.ts
var Container = __webpack_require__(4023);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/Index/Hero/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2em;\n    font-weight: 500;\n    position: relative;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.625em;\n    font-weight: 700;\n    margin-top: 0.625rem;\n    margin-bottom: 1.875rem;\n    position: relative;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    max-width: 500px;\n    line-height: 27px;\n    font-size: 1.25em;\n    color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 3.75rem;\n    margin-bottom: 5rem;\n    position: relative;\n    .button {\n        margin-bottom: 1.25rem;\n        &:first-child {\n            margin-right: 1.25rem;\n        }\n    }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: ",
        "vh;\n    width: ",
        "vh;\n    position: absolute;\n    border-radius: 100%;\n    top: 50%;\n    left: 50%;\n    border: 1px solid ",
        ";\n    transform: translate(-50%, -50%);\n    opacity: 0.5;\n    transition: 0.3s ease;\n    transition-delay: ",
        "s;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    margin-right: 30px;\n    margin-bottom: 15px;\n    background: rgba(255, 255, 255, 0.04);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(1px);\n    -webkit-backdrop-filter: blur(1px);\n    border: 2px solid transparent;\n    border-image: ",
        "\n        2;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 0.9rem;\n    background: ",
        ";\n    min-height: 100vh;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    .container {\n        position: relative;\n        z-index: 2;\n    }\n    @media (min-width: 1024px) {\n        .container {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            text-align: center;\n        }\n        font-size: 1.1rem;\n        ",
        " {\n            line-height: 2.1875rem;\n        }\n    }\n    @media (max-width: 768px) {\n        padding-top: 9.375rem;\n        padding-bottom: 3.75rem;\n        align-items: center;\n        ",
        " {\n            margin-bottom: 1.25rem;\n        }\n    }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const SubHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-e3aa7774-0"
})(_templateObject());
const Heading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-e3aa7774-1"
})(_templateObject1());
const LeadingText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e3aa7774-2"
})(_templateObject2(), (props)=>props.theme.palette.common.bodyText);
const HeroButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e3aa7774-3"
})(_templateObject3());
const BgCircle = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "bg-circle"
}).withConfig({
    componentId: "sc-e3aa7774-4"
})(_templateObject4(), (props)=>props.height, (props)=>props.height, (props)=>props.theme.palette.common.borderColor, (props)=>props.delay);
BgCircle.defaultProps = {
    height: 90,
    delay: 0
};
const HeroService = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e3aa7774-5"
})(_templateObject5(), (props)=>"linear-gradient(to right, ".concat(props.theme.palette.common.borderColor, ", ").concat(props.theme.palette.bgColor, ")"));
const HeroServices = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e3aa7774-6"
})(_templateObject6());
const HeroSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e3aa7774-7"
})(_templateObject7(), (props)=>props.theme.palette.gradient.main, LeadingText, HeroButtons);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.6_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(5453);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Index/Hero/BgCircles.tsx


const BgCircles = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 130,
                delay: 0.06
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 100,
                delay: 0.12
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 75,
                delay: 0.16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 60,
                delay: 0.18
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 40,
                delay: 0.2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircle, {
                height: 20,
                delay: 0.22
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/components/ui/FadeUp/index.tsx
var FadeUp = __webpack_require__(1066);
;// CONCATENATED MODULE: ./src/components/Index/Hero/index.tsx







const Hero = ()=>{
    const handleMouseEnter = ()=>{
        const bgCircles = document.querySelectorAll(".bg-circle");
        bgCircles.forEach((bc)=>{
            bc.style.transform = "translate(-50%, -50%) scale(1.1)";
        });
    };
    const handleMouseLeave = ()=>{
        const bgCircles = document.querySelectorAll(".bg-circle");
        bgCircles.forEach((bc)=>{
            bc.style.transform = "translate(-50%, -50%) scale(1)";
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroSection, {
        id: "home",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading, {
                            children: "Design & Code"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                        delay: 0.3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            children: "Solutions for targeted customers"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                        delay: 0.4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadingText, {
                            children: "Creating leading websites with experiences that matter once a customer enters."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroButtons, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                                delay: 0.6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    prefetch: false,
                                    href: "#work",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        "aria-label": "Previous work",
                                        onMouseEnter: handleMouseEnter,
                                        onMouseLeave: handleMouseLeave,
                                        children: "Previous Work"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                                delay: 0.9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contact",
                                    "aria-label": "Hire me",
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        "aria-label": "Hire me",
                                        onMouseEnter: handleMouseEnter,
                                        onMouseLeave: handleMouseLeave,
                                        secondary: true,
                                        children: "Hire Me"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroServices, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                                delay: 0.9,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroService, {
                                    children: "Front-End engineering"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                                delay: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroService, {
                                    children: "Back-End engineering"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                                delay: 1.1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroService, {
                                    children: "UI/UX Design"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgCircles, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ui/SectionTitle/index.tsx + 1 modules
var SectionTitle = __webpack_require__(6227);
;// CONCATENATED MODULE: ./src/components/Index/Services/style.ts

function style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-bottom: 2.5rem;\n    width: 50%;\n    font-size: 0.8rem;\n    font-weight: 500;\n    &:nth-child(odd) {\n        padding-right: 5px;\n    }\n    &:nth-child(even) {\n        padding-left: 5px;\n    }\n    img {\n        flex-shrink: 0;\n        margin-right: 10px !important;\n    }\n"
    ]);
    style_templateObject = function() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n"
    ]);
    style_templateObject1 = function() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    display: flex;\n    flex-direction: column;\n    background: white;\n    position: relative;\n    margin-top: 4rem;\n    padding: 0 30px;\n    > * {\n        position: relative;\n        z-index: 1;\n    }\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 50%;\n        box-shadow: rgb(24 39 75 / 12%) 0px 6px 12px -6px,\n            rgb(24 39 75 / 8%) 0px 8px 24px -4px;\n        z-index: 0;\n    }\n\n    &:after {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: ',
        ";\n    }\n    .section-title {\n        margin-top: 2.5rem;\n        margin-bottom: 1.25rem;\n    }\n    hr {\n        width: 100%;\n        background: ",
        ";\n        opacity: 0.2;\n    }\n\n    @media (min-width: 600px) {\n        padding: 5rem;\n        .section-title {\n            margin-top: 0;\n        }\n        hr {\n            margin: 1.875rem 0 3.125rem 0;\n        }\n        ",
        " {\n            font-size: 1rem;\n        }\n    }\n\n    @media (min-width: 768px) {\n        ",
        " {\n            width: calc(100% / 3);\n            padding: 0 !important;\n        }\n    }\n\n    @media (min-width: 1024px) {\n        ",
        " {\n            width: calc(100% / 4);\n        }\n    }\n\n    @media (min-width: 1280px) {\n        ",
        " {\n            width: 140px !important;\n            margin-bottom: 2.5rem !important;\n            margin-right: 3.75rem !important;\n        }\n    }\n"
    ]);
    style_templateObject2 = function() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0.625rem;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 1rem;\n    margin-right: 1.25rem;\n    margin-bottom: 1.25rem;\n    svg {\n        margin-right: 0.625rem;\n        fill: ",
        ";\n    }\n"
    ]);
    style_templateObject3 = function() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 1.875rem;\n    display: flex;\n    flex-wrap: wrap;\n"
    ]);
    style_templateObject4 = function() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 1.5625rem;\n    margin-top: 1.25rem;\n    border-left: 2px solid ",
        ";\n    .section-title {\n        margin-bottom: 1.25rem;\n        h2 {\n            font-size: 1.3rem;\n        }\n    }\n    p {\n        line-height: 1.6875rem;\n        margin-bottom: 1.25rem;\n        max-width: 65ch;\n    }\n"
    ]);
    style_templateObject5 = function() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    @media (min-width: 1024px) {\n        flex-direction: row;\n        ",
        " {\n            margin-top: 0;\n        }\n    }\n"
    ]);
    style_templateObject6 = function() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    position: relative;\n    > * {\n        position: relative;\n    }\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 70%;\n        background: ',
        ";\n    }\n"
    ]);
    style_templateObject7 = function() {
        return data;
    };
    return data;
}

const TechnologyElement = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cf331f82-0"
})(style_templateObject());
const TechnologiesContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-cf331f82-1"
})(style_templateObject1());
const TechnologiesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf331f82-2"
})(style_templateObject2(), (props)=>props.theme.palette.gradient.services, (props)=>props.theme.palette.common.borderColor, TechnologyElement, TechnologyElement, TechnologyElement, TechnologyElement);
const ServiceSingle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf331f82-3"
})(style_templateObject3(), (props)=>props.theme.palette.primary.main);
const ServicesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf331f82-4"
})(style_templateObject4());
const About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf331f82-5"
})(style_templateObject5(), (props)=>props.theme.palette.primary.main);
const ServiceSectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf331f82-6"
})(style_templateObject6(), About);
const ServiceSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-cf331f82-7"
})(style_templateObject7(), (props)=>props.theme.palette.bgPrimaryLight);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.6_biqbaboplfbrettd7655fr4n2y/node_modules/next/image.js
var next_image = __webpack_require__(3366);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/ui/Icons.tsx + 13 modules
var Icons = __webpack_require__(3508);
;// CONCATENATED MODULE: ./src/types/Technology.ts
var TechnologyType;
(function(TechnologyType) {
    TechnologyType["DEV"] = "dev";
    TechnologyType["DESIGN"] = "design";
})(TechnologyType || (TechnologyType = {}));

;// CONCATENATED MODULE: ./src/helpers/date.ts
function isValidDate(dateString) {
    const timestamp = Date.parse(dateString);
    return !isNaN(timestamp);
}
function yearsToNow(date) {
    if (!date) {
        return;
    }
    if (!isValidDate(date)) {
        return;
    }
    const startDateMs = new Date(date).getTime();
    const currentDateMs = new Date().getTime();
    const differentInMs = currentDateMs - startDateMs;
    const years = differentInMs / (1000 * 60 * 60 * 24 * 365);
    return years.toFixed(0);
}

;// CONCATENATED MODULE: ./src/components/Index/Services/index.tsx








const Services = (param)=>{
    let { technologies  } = param;
    const dev = technologies.filter((t)=>t.type === TechnologyType.DEV);
    const design = technologies.filter((t)=>t.type === TechnologyType.DESIGN);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceSection, {
        id: "services",
        className: "body-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceSectionHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            subHeading: "Services",
                            heading: "Latest & Reliable Technologies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(About, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                    heading: "A little about me"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "I am Benali Zakaria a ",
                                        yearsToNow("1997"),
                                        " years old self-taught Full stack developer and UI/UX Designer with ",
                                        yearsToNow("2020-06-01"),
                                        " years of experience.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "I've worked with various clients from individuals to startups on various projects, which made me gain more experience and be more flexible in finding the right solutions for targeted customers.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "This also makes me confident that I will provide you with the best solutions for your business."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServicesContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceSingle, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BrokenCheck */.vF, {}),
                                                "Can-do attitude"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceSingle, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BrokenCheck */.vF, {}),
                                                "More than 30 happy clients globally"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceSingle, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BrokenCheck */.vF, {}),
                                                "Creative and results-driven"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TechnologiesWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            subHeading: "Development",
                            heading: "Full Stack",
                            headingId: "dev-technologies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnologiesContainer, {
                            "aria-labelledby": "dev-technologies",
                            children: dev.map((d, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(TechnologyElement, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: "35",
                                            width: "35",
                                            src: d.icon.url,
                                            alt: "".concat(d.name, " Technology")
                                        }),
                                        d.name
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            subHeading: "Design",
                            heading: "UI & UX Design",
                            headingId: "design-technologies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnologiesContainer, {
                            "aria-labelledby": "design-technologies",
                            children: design.map((d, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(TechnologyElement, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            height: "35",
                                            width: "35",
                                            src: d.icon.url,
                                            alt: "".concat(d.name, " Technology")
                                        }),
                                        d.name
                                    ]
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Index/Why/style.ts

function Why_style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    text-transform: capitalize;\n    margin-bottom: 1.25rem;\n    svg {\n        margin-right: 10px;\n        path {\n            fill: ",
        ";\n        }\n    }\n"
    ]);
    Why_style_templateObject = function() {
        return data;
    };
    return data;
}
function Why_style_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    p {\n        line-height: 1.5625rem;\n        color: ",
        ";\n        margin-bottom: 1.875rem;\n        max-width: 35ch;\n    }\n    img {\n        object-fit: contain;\n        max-width: 100%;\n    }\n    &:last-child {\n        margin-top: 3.75rem;\n    }\n    @media (max-width: 1024px) {\n        align-items: flex-start;\n        flex-direction: column !important;\n    }\n"
    ]);
    Why_style_templateObject1 = function() {
        return data;
    };
    return data;
}
function Why_style_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ":last-child {\n        flex-direction: row-reverse;\n    }\n    .container {\n        display: flex;\n        flex-direction: column;\n    }\n"
    ]);
    Why_style_templateObject2 = function() {
        return data;
    };
    return data;
}

const BenefitSingle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26c153e4-0"
})(Why_style_templateObject(), (props)=>props.theme.palette.primary.main);
const BenefitWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-26c153e4-1"
})(Why_style_templateObject1(), (props)=>props.theme.palette.common.bodyText);
const WhySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-26c153e4-2"
})(Why_style_templateObject2(), BenefitWrapper);

// EXTERNAL MODULE: ./src/components/ui/NextExternalImage.tsx
var NextExternalImage = __webpack_require__(8834);
;// CONCATENATED MODULE: ./src/components/Index/Why/index.tsx






const WhyMe = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhySection, {
        id: "why",
        className: "body-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                    heading: "Scalable Coding."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "As a developer, I know the struggle of maintaining an existing project with a bad base code or practices that's why I create code for humans to read and for machines to execute."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "Clean code."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "Well documented code."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "Performant and secure."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "Scalable and easy to maintain."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                            alt: "Floating laptops With UI Design Preview",
                            src: "carbon.webp",
                            sizes: "(max-width:600px) 100vw, 40vw",
                            height: "400",
                            width: "700"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                                    heading: "Elegant Design."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "On average a user stays on a page for 10-20 seconds, In those few seconds, it is my job to attract the user and convert it into a customer."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "User interface design."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "User experience design."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitSingle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedSMCheck */._h, {}),
                                        "Pixel Perfect."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                            alt: "Floating laptops With UI Design Preview",
                            src: "floating_laptops.webp",
                            sizes: "(max-width:600px) 100vw, 40vw",
                            height: "500",
                            width: "700"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/vanilla-tilt@1.7.2/node_modules/vanilla-tilt/lib/vanilla-tilt.js
var vanilla_tilt = __webpack_require__(8900);
var vanilla_tilt_default = /*#__PURE__*/__webpack_require__.n(vanilla_tilt);
;// CONCATENATED MODULE: ./src/components/Index/Work/ProjectCard/style.ts

function ProjectCard_style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    width: 100%;\n    right: 0;\n    top: 0;\n    position: absolute;\n    display: none;\n"
    ]);
    ProjectCard_style_templateObject = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: rgba(255, 255, 255, 0.6);\n    margin-top: 1.25rem;\n    max-width: 28ch;\n    margin-bottom: auto;\n    transform: translateZ(20px);\n"
    ]);
    ProjectCard_style_templateObject1 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.375rem;\n    font-weight: 600;\n    width: 100%;\n    max-width: 530px;\n    margin: 0px;\n    transform: translateZ(20px);\n"
    ]);
    ProjectCard_style_templateObject2 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    width: 100%;\n    position: relative;\n    img {\n        object-fit: cover;\n    }\n"
    ]);
    ProjectCard_style_templateObject3 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.2);\n    padding: 0.3125rem 0.625rem;\n    font-size: 0.75rem;\n    color: white;\n    border-radius: 4px;\n    margin-right: 0.625rem;\n    margin-bottom: 0.625rem;\n    img {\n        margin-right: 0.625rem !important;\n    }\n"
    ]);
    ProjectCard_style_templateObject4 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 50px;\n    max-width: 340px;\n    position: relative;\n    transform: translateZ(20px);\n"
    ]);
    ProjectCard_style_templateObject5 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: ",
        ";\n    padding: 2.5rem 1.375rem 1.25rem 1.5625rem;\n    height: 100%;\n    width: 100%;\n    position: relative;\n    transform-style: preserve-3d;\n    transform: perspective(1000px);\n"
    ]);
    ProjectCard_style_templateObject6 = function() {
        return data;
    };
    return data;
}
function ProjectCard_style_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 3.125rem;\n    width: 100%;\n\n    @media (min-width: 1200px) {\n        width: 50%;\n        &:nth-child(odd) {\n            padding-right: 1.5625rem;\n        }\n        &:nth-child(even) {\n            padding-left: 1.5625rem;\n        }\n    }\n    @media (min-width: 600px) {\n        min-height: 400px;\n        ",
        " {\n            display: block;\n        }\n    }\n"
    ]);
    ProjectCard_style_templateObject7 = function() {
        return data;
    };
    return data;
}

const ProjectImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d07a2260-0"
})(ProjectCard_style_templateObject());
const ProjectDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d07a2260-1"
})(ProjectCard_style_templateObject1());
const ProjectName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d07a2260-2"
})(ProjectCard_style_templateObject2());
const ProjectImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d07a2260-3"
})(ProjectCard_style_templateObject3());
const Technology = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d07a2260-4"
})(ProjectCard_style_templateObject4());
const style_TechnologiesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d07a2260-5"
})(ProjectCard_style_templateObject5());
const ProjectCardContainer = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-d07a2260-6"
})(ProjectCard_style_templateObject6(), (props)=>props.bgColor);
const ProjectCardWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-d07a2260-7"
})(ProjectCard_style_templateObject7(), ProjectImage);

;// CONCATENATED MODULE: ./src/components/Index/Work/ProjectCard/index.tsx





const ProjectCard = (param)=>{
    let { project  } = param;
    const anchorTag = /*#__PURE__*/ react.createRef();
    const { title , showcase , description , stack , link , upper_color , lower_color  } = project;
    (0,react.useEffect)(()=>{
        const options = {
            "scale": 1,
            "speed": 1000,
            "max": 5,
            "glare": true,
            "max-glare": 0.2
        };
        const anchor = anchorTag.current;
        if (anchor) {
            vanilla_tilt_default().init(anchor, options);
        }
    }, [
        anchorTag
    ]);
    const bgColor = "linear-gradient(".concat(upper_color, " 0%, ").concat(lower_color, " 100%)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCardWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectCardContainer, {
            bgColor: bgColor,
            href: link,
            ref: anchorTag,
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: showcase.url,
                            alt: "".concat(title, " Project Showcase"),
                            sizes: "(max-width:1024px) 100vw, 35vw",
                            fill: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectName, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDesc, {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_TechnologiesContainer, {
                    children: [
                        stack.slice(0, 5).map((technology, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Technology, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "Technology icon",
                                        className: "tech-icon",
                                        height: "15",
                                        width: "15",
                                        src: technology.icon.url
                                    }),
                                    technology.name
                                ]
                            }, i)),
                        stack.length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Technology, {
                            children: [
                                "+",
                                stack.length - 5,
                                " more"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Index/Work/style.ts

function Work_style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 1.875rem;\n"
    ]);
    Work_style_templateObject = function() {
        return data;
    };
    return data;
}

const ProjectContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-490fccd0-0"
})(Work_style_templateObject());

;// CONCATENATED MODULE: ./src/components/Index/Work/index.tsx





const Work = (param)=>{
    let { projects  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "work",
        className: "body-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                    heading: "Various types of projects",
                    subHeading: "Work",
                    headingId: "all-projects-heading"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectContainer, {
                    "aria-labelledby": "all-projects-heading",
                    children: projects.map((project, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard, {
                            project: project
                        }, i))
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/SEO/index.tsx
var SEO = __webpack_require__(3194);
;// CONCATENATED MODULE: ./src/pages/index.tsx







const Home = (param)=>{
    let { technologies , projects  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* HomeSeo */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Work, {
                projects: projects
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyMe, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                technologies: technologies
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMe/* FindMe */.T, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 8900:
/***/ (function(module) {

"use strict";


var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.7.2
 */

var VanillaTilt = function () {
  function VanillaTilt(element) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, VanillaTilt);

    if (!(element instanceof Node)) {
      throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
    }

    this.width = null;
    this.height = null;
    this.clientWidth = null;
    this.clientHeight = null;
    this.left = null;
    this.top = null;

    // for Gyroscope sampling
    this.gammazero = null;
    this.betazero = null;
    this.lastgammazero = null;
    this.lastbetazero = null;

    this.transitionTimeout = null;
    this.updateCall = null;
    this.event = null;

    this.updateBind = this.update.bind(this);
    this.resetBind = this.reset.bind(this);

    this.element = element;
    this.settings = this.extendSettings(settings);

    this.reverse = this.settings.reverse ? -1 : 1;
    this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
    this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
    this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
    this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
    this.gyroscopeSamples = this.settings.gyroscopeSamples;

    this.elementListener = this.getElementListener();

    if (this.glare) {
      this.prepareGlare();
    }

    if (this.fullPageListening) {
      this.updateClientSize();
    }

    this.addEventListeners();
    this.reset();
    this.updateInitialPosition();
  }

  VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
    return setting === "" || setting === true || setting === 1;
  };

  /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */


  VanillaTilt.prototype.getElementListener = function getElementListener() {
    if (this.fullPageListening) {
      return window.document;
    }

    if (typeof this.settings["mouse-event-element"] === "string") {
      var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);

      if (mouseEventElement) {
        return mouseEventElement;
      }
    }

    if (this.settings["mouse-event-element"] instanceof Node) {
      return this.settings["mouse-event-element"];
    }

    return this.element;
  };

  /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */


  VanillaTilt.prototype.addEventListeners = function addEventListeners() {
    this.onMouseEnterBind = this.onMouseEnter.bind(this);
    this.onMouseMoveBind = this.onMouseMove.bind(this);
    this.onMouseLeaveBind = this.onMouseLeave.bind(this);
    this.onWindowResizeBind = this.onWindowResize.bind(this);
    this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);

    this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
    this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
    this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);

    if (this.glare || this.fullPageListening) {
      window.addEventListener("resize", this.onWindowResizeBind);
    }

    if (this.gyroscope) {
      window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    }
  };

  /**
   * Method remove event listeners from current this.elementListener
   */


  VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
    this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
    this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
    this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);

    if (this.gyroscope) {
      window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
    }

    if (this.glare || this.fullPageListening) {
      window.removeEventListener("resize", this.onWindowResizeBind);
    }
  };

  VanillaTilt.prototype.destroy = function destroy() {
    clearTimeout(this.transitionTimeout);
    if (this.updateCall !== null) {
      cancelAnimationFrame(this.updateCall);
    }

    this.reset();

    this.removeEventListeners();
    this.element.vanillaTilt = null;
    delete this.element.vanillaTilt;

    this.element = null;
  };

  VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
    if (event.gamma === null || event.beta === null) {
      return;
    }

    this.updateElementPosition();

    if (this.gyroscopeSamples > 0) {
      this.lastgammazero = this.gammazero;
      this.lastbetazero = this.betazero;

      if (this.gammazero === null) {
        this.gammazero = event.gamma;
        this.betazero = event.beta;
      } else {
        this.gammazero = (event.gamma + this.lastgammazero) / 2;
        this.betazero = (event.beta + this.lastbetazero) / 2;
      }

      this.gyroscopeSamples -= 1;
    }

    var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
    var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;

    var degreesPerPixelX = totalAngleX / this.width;
    var degreesPerPixelY = totalAngleY / this.height;

    var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
    var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);

    var posX = angleX / degreesPerPixelX;
    var posY = angleY / degreesPerPixelY;

    if (this.updateCall !== null) {
      cancelAnimationFrame(this.updateCall);
    }

    this.event = {
      clientX: posX + this.left,
      clientY: posY + this.top
    };

    this.updateCall = requestAnimationFrame(this.updateBind);
  };

  VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
    this.updateElementPosition();
    this.element.style.willChange = "transform";
    this.setTransition();
  };

  VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
    if (this.updateCall !== null) {
      cancelAnimationFrame(this.updateCall);
    }

    this.event = event;
    this.updateCall = requestAnimationFrame(this.updateBind);
  };

  VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
    this.setTransition();

    if (this.settings.reset) {
      requestAnimationFrame(this.resetBind);
    }
  };

  VanillaTilt.prototype.reset = function reset() {
    this.event = {
      clientX: this.left + this.width / 2,
      clientY: this.top + this.height / 2
    };

    if (this.element && this.element.style) {
      this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(0deg) " + "rotateY(0deg) " + "scale3d(1, 1, 1)";
    }

    this.resetGlare();
  };

  VanillaTilt.prototype.resetGlare = function resetGlare() {
    if (this.glare) {
      this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
      this.glareElement.style.opacity = "0";
    }
  };

  VanillaTilt.prototype.updateInitialPosition = function updateInitialPosition() {
    if (this.settings.startX === 0 && this.settings.startY === 0) {
      return;
    }

    this.onMouseEnter();

    if (this.fullPageListening) {
      this.event = {
        clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
        clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
      };
    } else {
      this.event = {
        clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
        clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
      };
    }

    var backupScale = this.settings.scale;
    this.settings.scale = 1;
    this.update();
    this.settings.scale = backupScale;
    this.resetGlare();
  };

  VanillaTilt.prototype.getValues = function getValues() {
    var x = void 0,
        y = void 0;

    if (this.fullPageListening) {
      x = this.event.clientX / this.clientWidth;
      y = this.event.clientY / this.clientHeight;
    } else {
      x = (this.event.clientX - this.left) / this.width;
      y = (this.event.clientY - this.top) / this.height;
    }

    x = Math.min(Math.max(x, 0), 1);
    y = Math.min(Math.max(y, 0), 1);

    var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
    var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
    var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);

    return {
      tiltX: tiltX,
      tiltY: tiltY,
      percentageX: x * 100,
      percentageY: y * 100,
      angle: angle
    };
  };

  VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
    var rect = this.element.getBoundingClientRect();

    this.width = this.element.offsetWidth;
    this.height = this.element.offsetHeight;
    this.left = rect.left;
    this.top = rect.top;
  };

  VanillaTilt.prototype.update = function update() {
    var values = this.getValues();

    this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";

    if (this.glare) {
      this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
      this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
    }

    this.element.dispatchEvent(new CustomEvent("tiltChange", {
      "detail": values
    }));

    this.updateCall = null;
  };

  /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */


  VanillaTilt.prototype.prepareGlare = function prepareGlare() {
    // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
    if (!this.glarePrerender) {
      // Create glare element
      var jsTiltGlare = document.createElement("div");
      jsTiltGlare.classList.add("js-tilt-glare");

      var jsTiltGlareInner = document.createElement("div");
      jsTiltGlareInner.classList.add("js-tilt-glare-inner");

      jsTiltGlare.appendChild(jsTiltGlareInner);
      this.element.appendChild(jsTiltGlare);
    }

    this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
    this.glareElement = this.element.querySelector(".js-tilt-glare-inner");

    if (this.glarePrerender) {
      return;
    }

    Object.assign(this.glareElementWrapper.style, {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%",
      "overflow": "hidden",
      "pointer-events": "none"
    });

    Object.assign(this.glareElement.style, {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "pointer-events": "none",
      "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
      "transform": "rotate(180deg) translate(-50%, -50%)",
      "transform-origin": "0% 0%",
      "opacity": "0"
    });

    this.updateGlareSize();
  };

  VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
    if (this.glare) {
      var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;

      Object.assign(this.glareElement.style, {
        "width": glareSize + "px",
        "height": glareSize + "px"
      });
    }
  };

  VanillaTilt.prototype.updateClientSize = function updateClientSize() {
    this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  };

  VanillaTilt.prototype.onWindowResize = function onWindowResize() {
    this.updateGlareSize();
    this.updateClientSize();
  };

  VanillaTilt.prototype.setTransition = function setTransition() {
    var _this = this;

    clearTimeout(this.transitionTimeout);
    this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
    if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;

    this.transitionTimeout = setTimeout(function () {
      _this.element.style.transition = "";
      if (_this.glare) {
        _this.glareElement.style.transition = "";
      }
    }, this.settings.speed);
  };

  /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be disabled. Can be X or Y
   * @param {boolean} settings.glare - What axis should be disabled. Can be X or Y
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */


  VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
    var defaultSettings = {
      reverse: false,
      max: 15,
      startX: 0,
      startY: 0,
      perspective: 1000,
      easing: "cubic-bezier(.03,.98,.52,.99)",
      scale: 1,
      speed: 300,
      transition: true,
      axis: null,
      glare: false,
      "max-glare": 1,
      "glare-prerender": false,
      "full-page-listening": false,
      "mouse-event-element": null,
      reset: true,
      gyroscope: true,
      gyroscopeMinAngleX: -45,
      gyroscopeMaxAngleX: 45,
      gyroscopeMinAngleY: -45,
      gyroscopeMaxAngleY: 45,
      gyroscopeSamples: 10
    };

    var newSettings = {};
    for (var property in defaultSettings) {
      if (property in settings) {
        newSettings[property] = settings[property];
      } else if (this.element.hasAttribute("data-tilt-" + property)) {
        var attribute = this.element.getAttribute("data-tilt-" + property);
        try {
          newSettings[property] = JSON.parse(attribute);
        } catch (e) {
          newSettings[property] = attribute;
        }
      } else {
        newSettings[property] = defaultSettings[property];
      }
    }

    return newSettings;
  };

  VanillaTilt.init = function init(elements, settings) {
    if (elements instanceof Node) {
      elements = [elements];
    }

    if (elements instanceof NodeList) {
      elements = [].slice.call(elements);
    }

    if (!(elements instanceof Array)) {
      return;
    }

    elements.forEach(function (element) {
      if (!("vanillaTilt" in element)) {
        element.vanillaTilt = new VanillaTilt(element, settings);
      }
    });
  };

  return VanillaTilt;
}();

if (typeof document !== "undefined") {
  /* expose the class to window */
  window.VanillaTilt = VanillaTilt;

  /**
   * Auto load
   */
  VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}

module.exports = VanillaTilt;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [433,774,888,179], function() { return __webpack_exec__(4998); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);